var Request = require('../helper/request');

function Feed(app, userId){
  var self = this;
  self.request = new Request(app);
  self.userId = userId;

  self.routes = {
  	index: {
  		url: '/iam/user/'+self.userId+'/feed',
  		method: 'GET'
  	}	
  };
}

Feed.prototype.index = function(){
	var self = this;
	return self.request.get(self.routes.index.url);
}

Feed.prototype.paginate = function(page){
  var self = this;
  var uri = self.routes.index.url + '?page=' + page;
  return self.request.get(uri);
}

module.exports = Feed;
